var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "demo" }, [
    _c("div", {
      staticClass: "chartBar",
      class: { echartNoData: !_vm.hasFlag && !_vm.showCharts },
      attrs: { id: "checkInTime" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }